<template>
<el-container  class="container">
  <div class="login-body">
    <div class="login-container">
      <div class="head">
        <img class="logo" src="../../../assets/images/logo_blue.png" align="absbottom"/>
        <!-- <span>学员管理系统</span> -->
        <div class="name">
          <!-- <div class="title">高山书院</div> -->
          <div class="tips">学员管理系统</div>
        </div>
      </div>
      <el-form status-icon label-position="top" :model="loginViewModel" :rules="rules"  ref="loginForm" class="login-form">
        <el-form-item label="账号" prop="username">
          <el-input type="text" prefix-icon="el-icon-user" v-model.trim="loginViewModel.userAccount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" prefix-icon="el-icon-view" v-model.trim="loginViewModel.userPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="color: #777;font-size:10px;">请使用员工邮箱登录</div>
          <el-button style="width: 100%" type="primary" @click="login">立即登录</el-button>
          <el-checkbox v-model="checked" @change="!checked">下次自动登录</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</el-container>
</template>

<script>
// import md5 from 'js-md5'
export default {
  name: 'Login',
  data () {
    return {
      loginViewModel: {
        userAccount: '',
        userPassword: '',
        verificationCode: ''
      },
      checked: true,
      isLogining: false,
      rules: {
        userAccount: [
          { required: 'true', message: '账号不能为空', trigger: 'blur' }
        ],
        userPassword: [
          { required: 'true', message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetForm: function () {
      this.$refs.loginForm.value.resetFields()
    },
    login: function () {
      let self = this
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.isLogining = true
          let model = {
            type: 100
          }
          model.secret = self.loginViewModel.userPassword
          model.account = self.loginViewModel.userAccount

          self.$http.post(self.$api.getApiAddress('/admin/login_by_email', 'AUTH_HOST'), model, false).then((res) => {
            console.log(res)
            self.isLogining = false
            console.log(res)
            return self.$store.dispatch('USER_LOGIN_ACTION', {
              token: res.data.token,
              name: res.data.name,
              avatar: res.data.avatar
            })
          }).then(() => {
            self.$router.push({
              path: '/'
            })
          }).catch((err) => {
            console.log(err)
            self.isLogining = false
            if (err.data) {
              self.$message({
                message: self.$helper.handleLoginErrorMsg(err), type: 'error'
              })
            } else {
              self.$message({
                message: '服务器错误', type: 'error'
              })
            }
          })
        }
      })
    }
  }

}
</script>

<style scoped>
  .container {
    height: 100vh;
  }
  .login-body {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #fff;
    /* background-image: linear-gradient(25deg, #077f7c, #3aa693, #5ecfaa, #7ffac2); */
  }
  .login-container {
    width: 420px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 21px 41px 0px rgba(0, 0, 0, 0.2);
  }
  .head {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 0 0 0;
  }

  .head .logo{
    width: 160px;
    margin-bottom: 32px;
  }
  .head .title {
    font-size: 28px;
    color: #1BAEAE;
    font-weight: bold;
  }
  .head .tips {
    font-size: 12px;
    color: #777;
  }
  .login-form {
    width: 70%;
    margin: 0 auto;
  }
</style>
<style>
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .login-form .el-form-item {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/views/login.vue